'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isScheduled = undefined;

var _isStatus = require('./isStatus');

var _messageStatusTypes = require('../constants/messageStatusTypes');

var isScheduled = exports.isScheduled = (0, _isStatus.isStatus)(_messageStatusTypes.SCHEDULED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isScheduled.js
// module id = 1131
// module chunks = 2 3